import { useEffect, useState } from "react";
import { AdminHeader } from "@trillion/ui/components/admin/admin-header";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { StatCard } from "@trillion/ui/components/admin/stat-card";
import {
  CalendarClock,
  CheckCircle2,
  Clock,
  Inbox,
  Loader2,
  XCircle,
} from "lucide-react";
import { toast } from "sonner";
import { jobsApi } from "@/lib/admin-api";
import type { JobStats } from "@/lib/jobs-types";

export function DashboardPage() {
  const [stats, setStats] = useState<JobStats | null>(null);

  useEffect(() => {
    jobsApi
      .stats()
      .then(setStats)
      .catch((err) =>
        toast.error(err instanceof Error ? err.message : "Failed to load job stats")
      );
  }, []);

  // Show counts once loaded; an em dash while pending.
  const v = (n: number | undefined) => (stats ? String(n ?? 0) : "—");

  return (
    <div className="flex flex-col">
      <AdminHeader title="Dashboard" />
      <div className="flex flex-col gap-6 p-6">
        <PageHeader title="Dashboard" description="Hangfire job overview" />
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
          <StatCard
            title="Enqueued"
            value={v(stats?.enqueued)}
            icon={<Inbox className="size-4" />}
            description="Awaiting a worker"
          />
          <StatCard
            title="Processing"
            value={v(stats?.processing)}
            icon={<Loader2 className="size-4" />}
            description="Running now"
          />
          <StatCard
            title="Scheduled"
            value={v(stats?.scheduled)}
            icon={<Clock className="size-4" />}
            description="Queued for later"
          />
          <StatCard
            title="Succeeded"
            value={v(stats?.succeeded)}
            icon={<CheckCircle2 className="size-4" />}
            description="Completed runs"
          />
          <StatCard
            title="Failed"
            value={v(stats?.failed)}
            icon={<XCircle className="size-4" />}
            description="Errored runs"
          />
          <StatCard
            title="Recurring"
            value={v(stats?.recurring)}
            icon={<CalendarClock className="size-4" />}
            description="Registered schedules"
          />
        </div>
      </div>
    </div>
  );
}
